import { Component, EventEmitter, ViewChild, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, map } from 'rxjs';
import {
  AddManualPersonAlertCommand,
  AlertCodeDto,
  CodeTablesClient,
  EducatorsClient,
} from 'src/shared/services/api.service';
import { catchValidationErrors } from 'src/shared/utilities/validator-utilities';

@Component({
  selector: 'cert-add-alert-modal',
  templateUrl: './add-alert-modal.component.html',
  styles: ``,
  standalone: false,
})
export class AddAlertModalComponent implements OnInit {
  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly codeTablesClient: CodeTablesClient,
    private readonly educatorsClient: EducatorsClient,
  ) {}

  @ViewChild('addAlertForm') form!: NgForm;

  personId!: number;

  selectedAlertCode!: AlertCodeDto;

  alertCodes$!: Observable<AlertCodeDto[]>;

  errorEmitter = new EventEmitter<any>();

  command: AddManualPersonAlertCommand = {
    personId: undefined!,
    alertCodeId: undefined!,
    additionalInformation: undefined,
  };

  ngOnInit() {
    this.command.personId = this.personId;
    this.alertCodes$ = this.codeTablesClient
      .getAlertCodesForManualAdd()
      .pipe(map((alertCodes) => alertCodes.filter((x) => x.canManuallyAddAlert)));
  }

  onClose(): void {
    this.activeModal.close();
  }

  onSubmit() {
    this.command.alertCodeId = this.selectedAlertCode.alertCodeId;

    this.educatorsClient
      .addManualPersonAlert(this.command)
      .pipe(catchValidationErrors(this.form, this.errorEmitter))
      .subscribe({
        next: () => this.activeModal.close(),
      });
  }
}
